import React, { useEffect, useMemo } from 'react';

import PropTypes from 'prop-types';
import SmartText from '@reuters-graphics/react-smart-text';
import WeeklyAverage from '@reuters-graphics/chart-module-weeklyaverage';
import classnames from 'classnames';
import { component } from './styles.module.scss';
import debounce from 'lodash/debounce';

// import useObservable from 'Components/hooks/observed';

const DailyCounts = ({ content, locale, counts, showLabels = true, reportingThreshold = null, dateRange = [] }) => {
  const chartContainer = React.createRef();

  // const isVisible = useObservable({ ref: chartContainer, rootMargin: '100px' });

  const avgChart = useMemo(() => new WeeklyAverage(), []);

  const resize = debounce(() => {
    avgChart
      .draw();
  }, 250);

  useEffect(() => {
    const data = reportingThreshold ? counts.filter(d =>
      d.reporting[0] / d.reporting[1] > reportingThreshold) : counts;

    avgChart
      .selection(chartContainer.current)
      .data(data)
      .props({
        locale,
        fill: '#63686E',
        stroke: '#eec331',
        height: 250,
        margin: {
          left: 30, right: 40, top: 10, bottom: 45,
        },
        labels: showLabels,
        variable_name: content.variableName,
        transition_elements: false,
        date_range: dateRange,
        text: {
          tooltip_suffix: content.tooltipSuffix,
          daily_numbers: content.dailyLabel,
          avg: content.avgLabel,
          per_pop_tt: content.popTooltip,
          no_data: content.noData,
        },
        y_min: 10,
        chart_formats: {
          // Format number for axis
          number: '~s',

          // Format number for tooltip
          number_tooltip: ',',

          // Date on tooltip
          date_tooltip: locale !== 'ja' ? '%B %e' : '%B %e日',

          // Date format for the x axis
          date: locale !== 'ja' ? '%b %e' : '%B %e日',
        },
      })
      .draw();
  }, [counts, dateRange, avgChart, locale, content, chartContainer, showLabels, reportingThreshold]);

  useEffect(() => {
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, [resize]);

  return (
    <div className={classnames(component, 'chart-container')}>
      <h6>
        <SmartText source={content.title} />
      </h6>
      <div className='weekly-average-chart-container' ref={chartContainer} />
    </div>
  );
};

DailyCounts.propTypes = {
  locale: PropTypes.string.isRequired,
  counts: PropTypes.array.isRequired,
  dateRange: PropTypes.array,
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    variableName: PropTypes.string.isRequired,
    tooltipSuffix: PropTypes.string.isRequired,
    dailyLabel: PropTypes.string.isRequired,
    avgLabel: PropTypes.string.isRequired,
    popTooltip: PropTypes.string.isRequired,
    noData: PropTypes.string.isRequired,
  }).isRequired,
  showLabels: PropTypes.bool,
  reportingThreshold: PropTypes.number,
};

export default DailyCounts;
